import React from 'react';
import { useNavigate } from 'react-router-dom';
import creatorPhoto from './neulogic-creator.jpg';

export default function About() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>About NeuLogic<span style={tmStyle}>™</span></h1>
      
      <section className="about-intro">
        <div style={{display:'flex', alignItems:'flex-start', gap:'28px', flexWrap:'wrap'}}>
          <img
            src={creatorPhoto}
            alt="Chris Neumann, creator of NeuLogic"
            style={{width:'160px', height:'213px', objectFit:'cover', borderRadius:'10px', flex:'0 0 auto', marginTop:'16px'}}
          />
          <div style={{flex:'1 1 420px'}}>
            <h2 style={{marginTop:0}}>Practical Software, Thoughtfully Built</h2>
            <p>
              NeuLogic<span style={tmStyle}>™</span> is an independent software business I created to develop focused desktop applications for real, everyday needs. Each app begins with a problem I have encountered personally: a task that should be simpler, a workflow that should be clearer, or a capability that existing software handles poorly.
            </p>
            <p>
              Nearly 30 years in software quality assurance, testing, and engineering shape the way I build: deliberate behavior, dependable results, clear interfaces, and close attention to the details that determine whether a tool feels useful or frustrating.
            </p>
          </div>
        </div>
      </section>
      
      <section className="about-purpose">
        <h2>Built Around the User</h2>
        <p>
          NeuLogic software is designed to do its job well without burying essential functions beneath clutter or unnecessary complexity. Features earn their place by solving practical problems, interfaces are organized to be intuitive, and every application is built to respect the user's time.
        </p>
        <p>
          Privacy and control are equally important. NeuLogic applications favor local operation and user-controlled storage, with encryption where appropriate, no telemetry, and no dependence on a cloud service merely to keep working. Some applications are free, while paid applications use straightforward licensing rather than recurring subscriptions.
        </p>
      </section>

      <section className="about-purpose">
        <h2>Why NeuLogic Exists</h2>
        <p>
          NeuLogic exists to create software that is focused, capable, and carefully finished without compromising features, design, or clarity where they matter. The goal is simple: build the kind of software I want to use myself and make it available to others who value the same things.
        </p>
      </section>
      
      <section className="about-support">
        <h2>Support</h2>
        <p>
          For technical support or product inquiries, please email <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}
